import * as fromSharedManagement from './shared_management_modals.js';
import * as fromNotificationSettings from './notification_settings.js';
import * as fromMiscSettings from './misc_settings.js';
import * as fromAccessSettings from './access_settings.js';
import * as fromAnalyticsForSite from './analytics_for_site.js';
import * as fromAnalyticsForRoute from './analytics_for_route.js';
import * as fromBranding from './branding.js';

// branding slice
export const getBrandedEmailTemplateOptionsForAuth = (state)=>
  fromBranding.getBrandedEmailTemplateOptionsForAuth(state.branding || {});

// notificationSettings slice
export const getNotificationSettingsById = (state)=>
  fromNotificationSettings.getNotificationSettingsById(state.notificationSettings || {});

export const getNotificationSettingsForUserByRouteId = (state, userId)=>
  fromNotificationSettings.getNotificationSettingsForUserByRouteId(state.notificationSettings || {}, userId);

export const getIsFetchingNotificationSettings = (state)=>
  fromNotificationSettings.getIsFetchingNotificationSettings(state.notificationSettings || {});

export const getRouteVisitNotificationSettings = (state)=>
  fromNotificationSettings.getRouteVisitNotificationSettings(state.notificationSettings || {});

export const getSiteApprovalRequestNotificationSettings = (state)=>
  fromNotificationSettings.getSiteApprovalRequestNotificationSettings(state.notificationSettings || {});

export const getSiteAssignmentNotificationSettings = (state)=>
  fromNotificationSettings.getSiteAssignmentNotificationSettings(state.notificationSettings || {});

export const getSiteAccessRequestNotificationSettings = (state)=>
  fromNotificationSettings.getSiteAccessRequestNotificationSettings(state.notificationSettings || {});

export const getFormResponseNotificationSettings = (state)=>
  fromNotificationSettings.getFormResponseNotificationSettings(state.notificationSettings || {});

export const getRouteVisitNotificationSettingsForRoute = (state, routeId)=>
  fromNotificationSettings.getRouteVisitNotificationSettingsForRoute(state.notificationSettings || {}, routeId);

export const getSiteApprovalRequestNotificationSettingsForSite = (state, siteId)=>
  fromNotificationSettings.getSiteApprovalRequestNotificationSettingsForSite(state.notificationSettings || {}, siteId);

export const getSiteAssignmentNotificationSettingsForSite = (state, siteId)=>
  fromNotificationSettings.getSiteAssignmentNotificationSettingsForSite(state.notificationSettings || {}, siteId);

export const getSiteAccessRequestNotificationSettingsForSite = (state, siteId)=>
  fromNotificationSettings.getSiteAccessRequestNotificationSettingsForSite(state.notificationSettings || {}, siteId);

export const getFormResponseNotificationSettingsForForm = (state, formId)=>
  fromNotificationSettings.getFormResponseNotificationSettingsForForm(state.notificationSettings || {}, formId);

export const getIsUserSubscribedToRouteVisitNotificationsForRoute = (state, userId, routeId)=>
  fromNotificationSettings.getIsUserSubscribedToRouteVisitNotificationsForRoute(
    state.notificationSettings || {},
    userId,
    routeId
  );

export const getIsUserSubscribedToSiteApprovalRequestNotificationsForSite = (state, userId, siteId)=>
  fromNotificationSettings.getIsUserSubscribedToSiteApprovalRequestNotificationsForSite(
    state.notificationSettings || {},
    userId,
    siteId
  );

export const getIsUserSubscribedToSiteAssignmentNotificationsForSite = (state, userId, siteId)=>
  fromNotificationSettings.getIsUserSubscribedToSiteAssignmentNotificationsForSite(
    state.notificationSettings || {},
    userId,
    siteId
  );

export const getIsUserSubscribedToSiteAccessRequestNotificationsForSite = (state, userId, siteId)=>
  fromNotificationSettings.getIsUserSubscribedToSiteAccessRequestNotificationsForSite(
    state.notificationSettings || {},
    userId,
    siteId
  );

export const getIsUserSubscribedToFormResponseNotificationsForForm = (state, userId, formId)=>
  fromNotificationSettings.getIsUserSubscribedToFormResponseNotificationsForForm(
    state.notificationSettings || {},
    userId,
    formId
  );


// miscSettings slice
export const getFolderIdForNewPage = (state)=>
  fromMiscSettings.getFolderIdForNewPage(state.miscSettings);


// sharedManagement slice
export const getModals = (state)=>
  fromSharedManagement.getModals(state.sharedManagementModals);

export const getLocationBeforeTransitions = (state)=>
  fromSharedManagement.getLocationBeforeTransitions(state.sharedManagementModals);

// accessSettings slice
export const getSamlIntegrations = (state)=>
  fromAccessSettings.getSamlIntegrations(state.accessSettings);

// analytics for site slice
export const resetCachedAnalyticsDataForSite = (state, siteId) =>
  fromAnalyticsForSite.resetCachedAnalyticsDataForSite(state.analyticsForSite, siteId);

export const getAnalyticsFiltersForPageId = (state, pageId)=>
  fromAnalyticsForSite.getAnalyticsFiltersForPageId(state.analyticsForSite, pageId);

export const getIsSiteDetailsTabLoading = (state, siteId)=>
  fromAnalyticsForSite.getIsSiteDetailsTabLoading(state.analyticsForSite, siteId);


export const getSiteVisitsChartDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getSiteVisitsChartDataForSite(state.analyticsForSite, siteId);

export const getSiteVisitsChartDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getSiteVisitsChartDataForSiteError(state.analyticsForSite, siteId);

export const getSiteVisitsTableDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getSiteVisitsTableDataForSite(state.analyticsForSite, siteId);

export const getSiteVisitsTableDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getSiteVisitsTableDataForSiteError(state.analyticsForSite, siteId);

export const getVisitSessionDataForSite = (state, siteId, pageSsessionUuid)=>
  fromAnalyticsForSite.getVisitSessionDataForSite(state.analyticsForSite, siteId, pageSsessionUuid);

export const getVisitSessionDataForSiteError = (state, siteId, pageSsessionUuid)=>
  fromAnalyticsForSite.getVisitSessionDataForSiteError(state.analyticsForSite, siteId, pageSsessionUuid);

export const getIsTopSubpagesDataForSiteLoading = (state, siteId)=>
  fromAnalyticsForSite.getIsTopSubpagesDataForSiteLoading(state.analyticsForSite, siteId);

export const getTopSubpagesDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getTopSubpagesDataForSite(state.analyticsForSite, siteId);

export const getTopSubpagesDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getTopSubpagesDataForSiteError(state.analyticsForSite, siteId);

export const getSubpagesDataForSite = (state, siteId, subpageId)=>
  fromAnalyticsForSite.getSubpagesDataForSite(state.analyticsForSite, siteId, subpageId);

export const getCachedSubpageDataForSite = (state, siteId, subpageId)=>
  fromAnalyticsForSite.getCachedSubpageDataForSite(state.analyticsForSite, siteId, subpageId);

export const getCachedSubpageDataForSiteError = (state, siteId, subpageId)=>
  fromAnalyticsForSite.getCachedSubpageDataForSiteError(state.analyticsForSite, siteId, subpageId);

export const getSubpageVisitsTableDataForSite = (state, siteId, subpageId)=>
  fromAnalyticsForSite.getSubpageVisitsTableDataForSite(state.analyticsForSite, siteId, subpageId);

export const getContentDataForSite = (state, siteId, contentUuid) =>
  fromAnalyticsForSite.getContentDataForSite(state.analyticsForSite, siteId, contentUuid);

export const getCachedContentDataForSite = (state, siteId, contentUuid) =>
  fromAnalyticsForSite.getCachedContentDataForSite(state.analyticsForSite, siteId, contentUuid);

export const getCachedContentDataForSiteError = (state, siteId, contentUuid) =>
  fromAnalyticsForSite.getCachedContentDataForSiteError(state.analyticsForSite, siteId, contentUuid);

export const getIsTopContentDataForSiteLoading = (state, siteId)=>
  fromAnalyticsForSite.getIsTopContentDataForSiteLoading(state.analyticsForSite, siteId);

export const getTopContentDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getTopContentDataForSite(state.analyticsForSite, siteId);

export const getTopContentDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getTopContentDataForSiteError(state.analyticsForSite, siteId);

export const getIsReferralDataForSiteLoading = (state, siteId)=>
  fromAnalyticsForSite.getIsReferralDataForSiteLoading(state.analyticsForSite, siteId);

export const getReferralDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getReferralDataForSite(state.analyticsForSite, siteId);

export const getReferralDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getReferralDataForSiteError(state.analyticsForSite, siteId);

export const getIsDeviceDataForSiteLoading = (state, siteId)=>
  fromAnalyticsForSite.getIsDeviceDataForSiteLoading(state.analyticsForSite, siteId);

export const getDeviceDataForSite = (state, siteId)=>
  fromAnalyticsForSite.getDeviceDataForSite(state.analyticsForSite, siteId);

export const getDeviceDataForSiteError = (state, siteId)=>
  fromAnalyticsForSite.getDeviceDataForSiteError(state.analyticsForSite, siteId);

export const getIsVisitSessionDataForSiteLoading = (state, siteId, pageSsessionUuid)=>
  fromAnalyticsForSite.getIsVisitSessionDataForSiteLoading(state.analyticsForSite, siteId, pageSsessionUuid);

export const getIsSubpageDataForSiteLoading = (state, siteId, subpageId)=>
  fromAnalyticsForSite.getIsSubpageDataForSiteLoading(state.analyticsForSite, siteId, subpageId);

export const getIsContentDataForSiteLoading = (state, siteId, contentUuid)=>
  fromAnalyticsForSite.getIsContentDataForSiteLoading(state.analyticsForSite, siteId, contentUuid);

// analytics for route slice

export const resetCachedAnalyticsDataForRoute = (state, routeId) =>
  fromAnalyticsForRoute.resetCachedAnalyticsDataForRoute(state.analyticsForRoute, routeId);

export const getAnalyticsFiltersForRouteId = (state, routeId)=>
  fromAnalyticsForRoute.getAnalyticsFiltersForRouteId(state.analyticsForRoute, routeId);

export const getIsRouteDetailsTabLoading = (state, routeId)=>
  fromAnalyticsForRoute.getIsRouteDetailsTabLoading(state.analyticsForRoute, routeId);

export const getRouteVisitsChartDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getRouteVisitsChartDataForRoute(state.analyticsForRoute, routeId);

export const getRouteVisitsChartDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getRouteVisitsChartDataForRouteError(state.analyticsForRoute, routeId);

export const getRouteVisitsTableDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getRouteVisitsTableDataForRoute(state.analyticsForRoute, routeId);

export const getRouteVisitsTableDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getRouteVisitsTableDataForRouteError(state.analyticsForRoute, routeId);

export const getVisitSessionDataForRoute = (state, routeId, pageSsessionUuid)=>
  fromAnalyticsForRoute.getVisitSessionDataForRoute(state.analyticsForRoute, routeId, pageSsessionUuid);

export const getVisitSessionDataForRouteError = (state, routeId, pageSsessionUuid)=>
  fromAnalyticsForRoute.getVisitSessionDataForRouteError(state.analyticsForRoute, routeId, pageSsessionUuid);
// subpages for route

export const getIsTopSubpagesDataForRouteLoading = (state, routeId)=>
  fromAnalyticsForRoute.getIsTopSubpagesDataForRouteLoading(state.analyticsForRoute, routeId);

export const getTopSubpagesDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getTopSubpagesDataForRoute(state.analyticsForRoute, routeId);

export const getTopSubpagesDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getTopSubpagesDataForRouteError(state.analyticsForRoute, routeId);

export const getSubpagesDataForRoute = (state, routeId, subpageId)=>
  fromAnalyticsForRoute.getSubpagesDataForRoute(state.analyticsForRoute, routeId, subpageId);

export const getCachedSubpageDataForRoute = (state, routeId, subpageId)=>
  fromAnalyticsForRoute.getCachedSubpageDataForRoute(state.analyticsForRoute, routeId, subpageId);

export const getCachedSubpageDataForRouteError = (state, routeId, subpageId)=>
  fromAnalyticsForRoute.getCachedSubpageDataForRouteError(state.analyticsForRoute, routeId, subpageId);

export const getIsSubpageDataForRouteLoading = (state, routeId, subpageId)=>
  fromAnalyticsForRoute.getIsSubpageDataForRouteLoading(state.analyticsForRoute, routeId, subpageId);

// content for route

export const getContentDataForRoute = (state, routeId, contentUuid) =>
  fromAnalyticsForRoute.getContentDataForRoute(state.analyticsForRoute, routeId, contentUuid);

export const getCachedContentDataForRoute = (state, routeId, contentUuid) =>
  fromAnalyticsForRoute.getCachedContentDataForRoute(state.analyticsForRoute, routeId, contentUuid);

export const getCachedContentDataForRouteError = (state, routeId, contentUuid) =>
  fromAnalyticsForRoute.getCachedContentDataForRouteError(state.analyticsForRoute, routeId, contentUuid);

export const getIsTopContentDataForRouteLoading = (state, routeId)=>
  fromAnalyticsForRoute.getIsTopContentDataForRouteLoading(state.analyticsForRoute, routeId);

export const getTopContentDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getTopContentDataForRoute(state.analyticsForRoute, routeId);

export const getTopContentDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getTopContentDataForRouteError(state.analyticsForRoute, routeId);

export const getIsContentDataForRouteLoading = (state, routeId, contentUuid)=>
  fromAnalyticsForRoute.getIsContentDataForRouteLoading(state.analyticsForRoute, routeId, contentUuid);

//


export const getIsReferralDataForRouteLoading = (state, routeId)=>
  fromAnalyticsForRoute.getIsReferralDataForRouteLoading(state.analyticsForRoute, routeId);

export const getReferralDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getReferralDataForRoute(state.analyticsForRoute, routeId);

export const getReferralDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getReferralDataForRouteError(state.analyticsForRoute, routeId);

export const getIsDeviceDataForRouteLoading = (state, routeId)=>
  fromAnalyticsForRoute.getIsDeviceDataForRouteLoading(state.analyticsForRoute, routeId);

export const getDeviceDataForRoute = (state, routeId)=>
  fromAnalyticsForRoute.getDeviceDataForRoute(state.analyticsForRoute, routeId);

export const getDeviceDataForRouteError = (state, routeId)=>
  fromAnalyticsForRoute.getDeviceDataForRouteError(state.analyticsForRoute, routeId);

export const getIsVisitSessionDataForRouteLoading = (state, routeId, pageSsessionUuid)=>
  fromAnalyticsForRoute.getIsVisitSessionDataForRouteLoading(state.analyticsForRoute, routeId, pageSsessionUuid);
